import React from "react";
import { useTranslation } from "react-i18next";
import { CSmartTable } from "@coreui/react-pro";
import Card from "react-bootstrap/Card";
import EmptyCell from "../../components/emptyCell/emptyCell";
import CustomeSelect from "../../components/customSelect/customSelect";
import CustomButton from "../../components/customButton/customButton";
import CustomLoadingHTML from "../../components/customLoadingHTML/customLoadingHTML";
import CustomeShimer from "../../components/customeShimer/customeShimer";
import Breadcrumbs from "../../components/customBreadcrumb/customBreadcrumb";
import Constant from "../../util/constant";

/**
 * A functional component that renders a driver management component.
 * @param {{object}} props - The props passed to the component.
 * @param {{function}} props.t - The translation function.
 * @param {{array}} props.columns - The columns to display in the table.
 * @param {{array}} props.UserItem - The items to display in the table.
 * @param {{number}} props.itemsPerPage - The number of items to display per page.
 * @param {{boolean}} props.placeHolderShimer - Whether to show a placeholder shimmer effect.
 * @param {{function}} props.onTableFilterChange - The function to call when the table filter changes.
 * @param {{string}} props.noDataFound - The message to
 */
const DriverMangmentComponent = (props) => {
  const { t } = useTranslation();
  const {
    columns,
    UserItem,
    itemsPerPage,
    placeHolderShimer,
    onTableFilterChange,
    noDataFound,
    noDataTitle,
    noDataDesc,
    addUserDepotName,
    onChangeMangerDepot,
    clearSearchButton,
    formatOptionLabel,
    components,
    changeFuction,
    selectInputRef,
    tableContainerRef,
    smarttableref,
    dimensions,
    headerHeight,
    breadcrumbHeight,
    tableFilterHeight,
    tabHeaderHeight,
    loaderHtml,
    loading,
    loaderButtonShow,
    searchValue,
    searchFilterClear,
  } = props;


  return (
    <>
      <React.Fragment>
        <div className="page-content NoticeType">
          <Breadcrumbs
            breadcrumbInner={false}
            breadcrumbMainTitle={true}
            breadcrumbItem={t("DRIVER_MANAGEMENT")}
          />
          <Card
            className={
              loading
                ? "Main_Card Main_Driver LoadingTable"
                : "Main_Card Main_Driver"
            }
          >
            <Card.Body className="p-0 activeTabSupplier">
              <div className="Main_Card_Body">
                <CSmartTable
                  ref={smarttableref}
                  cleaner
                  clickableRows
                  columns={columns}
                  columnFilter={true}
                  items={UserItem}
                  itemsPerPage={itemsPerPage}
                  columnSorter={true}
                  scopedColumns={{
                    fullname: (item) => {
                      const limitedContent = item?.fullname?.slice(0, 150);
                      return (
                        <>
                          <td
                            className={
                              item?.status === Constant.GENERALKEYS.INACTIVE && "disableTd"
                            }
                          >
                            <div className="userDetailsWrapper">
                              <p
                                className={`${
                                  limitedContent.length >= 20 && !limitedContent.includes(' ')
                                  ? 'breakeAll'
                                  : 'wordBrake'
                              }`}>
                                {placeHolderShimer && (
                                  <CustomeShimer />
                                )}
                                {limitedContent}
                              </p>
                            </div>
                          </td>
                        </>
                      );
                    },
                    emailid: (item) => {
                      return (
                        <>
                          <td
                            className={
                              item?.status === Constant.GENERALKEYS.INACTIVE && "disableTd"
                            }
                          >
                            <p 
                              className={`${
                                item?.emailid.length >= 20 && !item?.emailid.includes(' ')
                                ? 'breakeAll'
                                : 'wordBrake'
                              }`}>
                              {placeHolderShimer && (
                                <CustomeShimer />
                              )}
                              {item?.emailid}
                            </p>
                          </td>
                        </>
                      );
                    },
                    phone: (item) => {
                      return (
                        <>
                          <td
                            className={
                              item?.status === Constant.GENERALKEYS.INACTIVE && "disableTd"
                            }
                          >
                            <p 
                              className={`${
                                item?.phone.length >= 10 && !item?.phone.includes(' ')
                                ? 'breakeAll'
                                : 'wordBrake'
                              }`}>
                              {placeHolderShimer && (
                                <CustomeShimer />
                              )}
                              {item?.phone}
                            </p>
                          </td>
                        </>
                      );
                    },
                    payno: (item) => {
                      return (
                        <>
                          <td
                            className={
                              item?.status === Constant.GENERALKEYS.INACTIVE && "disableTd"
                            }
                          >
                            <p 
                              className={`${
                                item?.payno.length >= 10 && !item?.payno.includes(' ')
                                ? 'breakeAll'
                                : 'wordBrake'
                              }`}>
                              {placeHolderShimer && (
                                <CustomeShimer />
                              )}
                              {item?.payno}
                            </p>
                          </td>
                        </>
                      );
                    },
                    depotname: (item) => {
                      return (
                        <>
                          <td
                            className={
                              item?.status === Constant.GENERALKEYS.INACTIVE && item?.status ===  "disableTd"
                            }
                          >
                            {item?.depotedit === true ? (
                              <>
                                <CustomeSelect
                                  isClearable={true}
                                  ref={selectInputRef}
                                  closeMenuOnSelect={false}
                                  options={addUserDepotName}
                                  onChange={onChangeMangerDepot}
                                  formatOptionLabel={formatOptionLabel}
                                  components={components}
                                  defaultValue={item?.depotname}  
                                  className="react-select-container singleSelecter"
                                  classNamePrefix="react-select"                     
                                />
                                
                              </>
                            ) : (
                              <p>
                              {placeHolderShimer && (
                                <CustomeShimer />

                              )}
                              { item?.depotname === undefined ? '' : item?.depotname[0]?.depotname}
                            </p>
                            )}
                          </td>
                        </>
                      );
                    },
                    action: (item) => {
                      return (
                        <td className="">
                          <div className="ActionWrapper">
                            {placeHolderShimer && (
                              <CustomeShimer />
                            )}
                            <CustomButton
                              className="changeButton"
                              type="submit"
                              onClick={(e) => {
                                changeFuction(true, item, item?.depotedit);
                              }}
                              loading={loaderButtonShow}

                            >
                              { item?.depotedit === true ?
                              <>
                                {t("UPDATE")}
                              </>
                                :
                                <>
                                  {t("CHANGE")}
                                </>

                              }
                            </CustomButton>
                          </div>
                        </td>
                      );
                    },
                  }}
                  tableFilter
                  onTableFilterChange={onTableFilterChange}
                  tableFilterLabel={searchValue?.length > 0 && <button onClick={searchFilterClear} className="btn-close"></button>}
                  tableFilterPlaceholder={t("SEARCH_BY_NAME_OR_EMAIL_ADDRESS")}
                  tableProps={{
                    className: "DriverTable",
                    responsive: true,
                    striped: false,
                    hover: false,
                  }}
                  noItemsLabel={
                    !placeHolderShimer &&
                    <EmptyCell
                      emptyItems={UserItem}
                      noDataTitle={
                        UserItem?.length === 0 ? noDataFound : noDataTitle
                      }
                      noDataAddButton={true}
                      
                      noDataDesc={noDataDesc}
                      clearSearchButton={clearSearchButton}
                    />
                  }
                  tableBodyProps={{
                    className: "align-middle Table-Body-scroll",
                    style: {
                      height:
                        dimensions.height -
                        headerHeight -
                        breadcrumbHeight -
                        tableFilterHeight -
                        tabHeaderHeight -
                        (loading && loaderHtml) -
                        100,
                    },
                    ref: tableContainerRef,
                  }}
                />
                {loading && <CustomLoadingHTML />}
              </div>  
            </Card.Body>
          </Card>
        </div>
      </React.Fragment>
    </>
  );
};

export default DriverMangmentComponent;